import { AddMetadata, BlockKeys } from '../BlockCatalog';
import { BlockParameters, PipelineBlock } from '../PipelineBlock';
import { PipelineStage } from '../Stage';
import InvertStage, { InvertStageParams } from '../stages/transformations/InvertStage';
import { PipelinePhase } from '@visualizer/types';

export interface InvertParams extends BlockParameters, InvertStageParams {}

@AddMetadata({
    type: BlockKeys.Invert,
    name: 'Invert',
    description: 'Inverts all directions',
    unique: true,
    pipelinePhase: PipelinePhase.Pre,
    visible: false,
})
class InvertBlock extends PipelineBlock<InvertParams> {
    constructor(params: InvertParams, id?: string) {
        super(params, id);
    }

    protected override defineStages(): PipelineStage<any>[] {
        return [new InvertStage()];
    }
}

export default InvertBlock;
